export const personalDataValidationRules = {
    memberIdentifier: {
        isRequiredTrim: {
            value: true,
        },
    },
    existingEmail: {
        isRequiredTrim: {
            value: true,
        },
        regex: {
            value: {
                pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                customMessageKey: "validation.customMessages.emailAddressRegex",
            },
        },
    },
    confirmExistingEmail: {
        isRequiredTrim: {
            value: true,
        },
        mustMatch: {
            value: {
                field: "existingEmail",
                customMessageKey: "validation.customMessages.emailAddressMatch",
            },
        },
    },
    gRecaptchaResponse: {
        isRequiredTrim: {
            value: true
        }
    },
    checkCode: {
        isRequiredTrim: {
            value: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/personal-data/personalDataValidationRules.js